import * as React from 'react';
import { Section, Viewer } from '../../modules';
import { Station, StationFactory, Stationcategory, Sample, Result } from '../../resource/'; 
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { ShowLocationMap } from '../../modules/Map';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Label } from '@independent-software/typeui/controls/Label';
import { Latitude, Longitude } from '@independent-software/typeui/formatters/GIS';
import { Header } from '@independent-software/typeui/controls/Header';
import { Number } from '@independent-software/typeui/formatters/Number';
import { Output } from '../../controls/Output';
import { ListSamples } from '../Sample';
import { ListResults } from '../Result';

class ViewStation extends React.Component<IAuthProps & RouteComponentProps<{id:string}>, {}> {
  private handleEdit = () => {
    this.props.history.push(`/stations/edit/${parseInt(this.props.match.params.id)}`);
  }

  private handleDelete = () => {
    ToastService.toast("Station deleted.");
    this.props.history.push('/stations');
  }    

  private handleSampleClick = (item:Sample) => {
    this.props.history.push(`/samples/${item.id}`);
  }    

  public handleCategoryClick = (category: Stationcategory) => {
    this.props.history.push(`/stationcategories/${category.id}`);
  }

  private handleResultClick = (item: Result) => {
    this.props.history.push(`/results/${item.id}`);
  }  

  render() {
    let p = this.props;
    return (
      <Viewer<Station> 
        auth={p.auth}
        id={parseInt(p.match.params.id)}
        factory={StationFactory}
        canEdit='can_edit_stations'
        canDelete='can_delete_stations'
        onEdit={this.handleEdit}
        onDelete={this.handleDelete}
        content={(station: Station) => 
          <React.Fragment>
            <Section dark padded>
              <Header size="h1"><Label>{station.name}</Label> {station.description && <Label>{station.description}</Label>}</Header>
            </Section>
            <Tabs underlined>
              <Tabs.Pane label="Data">
                <Section padded="very">
                  <Flex stackable>
                    <Flex.Row>
                      <Flex.Column width={1}>
                        <Output label="Name" hint="Station name or code">{station.name}</Output>
                      </Flex.Column>
                      <Flex.Column width={2}>
                        <Output label="Description" hint="Optional station description">{station.description}</Output>
                      </Flex.Column>
                    </Flex.Row>
                    <Flex.Row>
                      <Flex.Column width={3}>
                        <Output nobackground label="Categories">
                          {station.stationcategories.map(cat => 
                            <Label onClick={p.auth.hasRight('can_view_stationcategories') ?  () => this.handleCategoryClick(cat) : null} basic tag key={cat.id}>{cat.name}</Label>
                          )}
                        </Output>
                      </Flex.Column>
                    </Flex.Row>
                    <Flex.Row>
                      <Flex.Column width={1}>
                        <Output nobackground label="Latitude" hint="Station latitude"><Label><Number value={station.latitude} decimals={6}/></Label> <Label><Latitude value={station.latitude}/></Label></Output>
                      </Flex.Column>
                      <Flex.Column width={2}>
                        <Flex.Columns count={2}>
                          <Output nobackground label="Longitude" hint="Station longitude"><Label><Number value={station.longitude} decimals={6}/></Label> <Label><Longitude value={station.longitude}/></Label></Output>
                          <Output label="Depth" hint="Distance from tidal datum in meters">{station.depth}</Output>
                        </Flex.Columns>
                      </Flex.Column>
                    </Flex.Row>
                  </Flex>
                </Section>
                <ShowLocationMap lat={station.latitude} lng={station.longitude} zoom={11}/>
              </Tabs.Pane>
              <Tabs.Pane label={<span>Samples <Label size="small">{station.samples_count}</Label></span>}>
                <ListSamples auth={p.auth} name="station_samples" stationId={station.id} onClick={p.auth.hasRight('can_view_samples') && this.handleSampleClick}/>
              </Tabs.Pane>                 
              <Tabs.Pane label="Results">
                <ListResults stationId={station.id} name="station_results" auth={p.auth} onClick={p.auth.hasRight('can_view_results') && this.handleResultClick}/>
              </Tabs.Pane>              
            </Tabs>
          </React.Fragment>}>
      </Viewer>
    );
  }
}

export { ViewStation };
